export const REQUEST_CAMPAIGNS_CHANNELS = "REQUEST_CAMPAIGNS_CHANNELS";
export const SET_CAMPAIGNS_CHANNELS = "SET_CAMPAIGNS_CHANNELS";
export const REVOKE_CAMPAIGNS_CHANNELS = "REVOKE_CAMPAIGNS_CHANNELS";
export const RESET_CAMPAIGNS_CHANNELS = "RESET_CAMPAIGNS_CHANNELS";

export const SET_ACTIVE_CHANNEL_DISPLAY = "SET_ACTIVE_CHANNEL_DISPLAY";
export const RESET_ACTIVE_CHANNEL_DISPLAY = "RESET_ACTIVE_CHANNEL_DISPLAY";

export const REQUEST_SET_ACTIVE_CHANNEL_CREDITS =
  "REQUEST_SET_ACTIVE_CHANNEL_CREDITS";
export const GRANT_SET_ACTIVE_CHANNEL_CREDITS =
  "GRANT_SET_ACTIVE_CHANNEL_CREDITS";
export const REVOKE_SET_ACTIVE_CHANNEL_CREDITS =
  "REVOKE_SET_ACTIVE_CHANNEL_CREDITS";
export const RESET_SET_ACTIVE_CHANNEL_CREDITS =
  "RESET_SET_ACTIVE_CHANNEL_CREDITS";

export const REQUEST_SET_ACTIVE_EMAIL_CHANNEL_STATISTICS =
  "REQUEST_SET_ACTIVE_EMAIL_CHANNEL_STATISTICS";
export const GRANT_SET_ACTIVE_EMAIL_CHANNEL_STATISTICS =
  "GRANT_SET_ACTIVE_EMAIL_CHANNEL_STATISTICS";
export const REVOKE_SET_ACTIVE_EMAIL_CHANNEL_STATISTICS =
  "REVOKE_SET_ACTIVE_EMAIL_CHANNEL_STATISTICS";
export const RESET_SET_ACTIVE_EMAIL_CHANNEL_STATISTICS =
  "RESET_SET_ACTIVE_EMAIL_CHANNEL_STATISTICS";

export const REQUEST_SET_ACTIVE_EMAIL_CHANNEL_REPUTATION =
  "REQUEST_SET_ACTIVE_EMAIL_CHANNEL_REPUTATION";
export const GRANT_SET_ACTIVE_EMAIL_CHANNEL_REPUTATION =
  "GRANT_SET_ACTIVE_EMAIL_CHANNEL_REPUTATION";
export const REVOKE_SET_ACTIVE_EMAIL_CHANNEL_REPUTATION =
  "REVOKE_SET_ACTIVE_EMAIL_CHANNEL_REPUTATION";
export const RESET_SET_ACTIVE_EMAIL_CHANNEL_REPUTATION =
  "RESET_SET_ACTIVE_EMAIL_CHANNEL_REPUTATION";

export const REQUEST_SET_ACTIVE_CHANNEL_SOURCE =
  "REQUEST_SET_ACTIVE_CHANNEL_SOURCE";
export const GRANT_SET_ACTIVE_CHANNEL_SOURCE =
  "GRANT_SET_ACTIVE_CHANNEL_SOURCE";
export const REVOKE_SET_ACTIVE_CHANNEL_SOURCE =
  "REVOKE_SET_ACTIVE_CHANNEL_SOURCE";
export const RESET_SET_ACTIVE_CHANNEL_SOURCE =
  "RESET_SET_ACTIVE_CHANNEL_SOURCE";

export const REQUEST_DELETE_EMAIL_CHANNEL_DOMAIN =
  "REQUEST_DELETE_EMAIL_CHANNEL_DOMAIN";
export const GRANT_DELETE_EMAIL_CHANNEL_DOMAIN =
  "GRANT_DELETE_EMAIL_CHANNEL_DOMAIN";
export const REVOKE_DELETE_EMAIL_CHANNEL_DOMAIN =
  "REVOKE_DELETE_EMAIL_CHANNEL_DOMAIN";
export const RESET_DELETE_EMAIL_CHANNEL_DOMAIN =
  "RESET_DELETE_EMAIL_CHANNEL_DOMAIN";

export const REQUEST_CHANNEL_EMAILS_CONTENT = "REQUEST_CHANNEL_EMAILS_CONTENT";
export const SET_CHANNEL_EMAILS_CONTENT = "SET_CHANNEL_EMAILS_CONTENT";
export const REVOKE_CHANNEL_EMAILS_CONTENT = "REVOKE_CHANNEL_EMAILS_CONTENT";
export const RESET_CHANNEL_EMAILS_CONTENT = "RESET_CHANNEL_EMAILS_CONTENT";

export const REQUEST_CHANNEL_SMS_CONTENT = "REQUEST_CHANNEL_SMS_CONTENT";
export const SET_CHANNEL_SMS_CONTENT = "SET_CHANNEL_SMS_CONTENT";
export const REVOKE_CHANNEL_SMS_CONTENT = "REVOKE_CHANNEL_SMS_CONTENT";
export const RESET_CHANNEL_SMS_CONTENT = "RESET_CHANNEL_SMS_CONTENT";

export const CHANGE_CAMPAIGNS_MODALS = "CHANGE_CAMPAIGNS_MODALS";

export const APPEND_CAMPAIGNS_DELETION_ARRAY =
  "APPEND_CAMPAIGNS_DELETION_ARRAY";
export const SUBTRACT_CAMPAIGNS_DELETION_ARRAY =
  "SUBTRACT_CAMPAIGNS_DELETION_ARRAY";

export const SET_ACTIVE_EMAIL_CHANNEL_STATISTICS_DATE =
  "SET_ACTIVE_EMAIL_CHANNEL_STATISTICS_DATE";
export const RESET_ACTIVE_EMAIL_CHANNEL_STATISTICS_DATE =
  "RESET_ACTIVE_EMAIL_CHANNEL_STATISTICS_DATE";

export const REQUEST_DISTRIBUTION_SELECTIONS =
  "REQUEST_DISTRIBUTION_SELECTIONS";
export const GRANT_DISTRIBUTION_SELECTIONS = "GRANT_DISTRIBUTION_SELECTIONS";
export const REVOKE_DISTRIBUTION_SELECTIONS = "REVOKE_DISTRIBUTION_SELECTIONS";
export const RESET_DISTRIBUTION_SELECTIONS = "RESET_DISTRIBUTION_SELECTIONS";

export const REQUEST_SEND_SMS_SELECTIONS = "REQUEST_SEND_SMS_SELECTIONS";
export const GRANT_SEND_SMS_SELECTIONS = "GRANT_SEND_SMS_SELECTIONS";
export const REVOKE_SEND_SMS_SELECTIONS = "REVOKE_SEND_SMS_SELECTIONS";
export const RESET_SEND_SMS_SELECTIONS = "RESET_SEND_SMS_SELECTIONS";

export const REQUEST_SEND_BULK_EMAILS = "REQUEST_SEND_BULK_EMAILS";
export const GRANT_SEND_BULK_EMAILS = "GRANT_SEND_BULK_EMAILS";
export const REVOKE_SEND_BULK_EMAILS = "REVOKE_SEND_BULK_EMAILS";
export const RESET_SEND_BULK_EMAILS = "RESET_SEND_BULK_EMAILS";

export const REQUEST_SEND_BULK_SMS = "REQUEST_SEND_BULK_SMS";
export const GRANT_SEND_BULK_SMS = "GRANT_SEND_BULK_SMS";
export const REVOKE_SEND_BULK_SMS = "REVOKE_SEND_BULK_SMS";
export const RESET_SEND_BULK_SMS = "RESET_SEND_BULK_SMS";

export const REQUEST_DOMAIN_AUTHENTICATION = "REQUEST_DOMAIN_AUTHENTICATION";
export const GRANT_DOMAIN_AUTHENTICATION = "GRANT_DOMAIN_AUTHENTICATION";
export const REVOKE_DOMAIN_AUTHENTICATION = "REVOKE_DOMAIN_AUTHENTICATION";
export const RESET_DOMAIN_AUTHENTICATION = "RESET_DOMAIN_AUTHENTICATION";

export const REQUEST_DOMAIN_VERIFICATION = "REQUEST_DOMAIN_VERIFICATION";
export const GRANT_DOMAIN_VERIFICATION = "GRANT_DOMAIN_VERIFICATION";
export const REVOKE_DOMAIN_VERIFICATION = "REVOKE_DOMAIN_VERIFICATION";
export const RESET_DOMAIN_VERIFICATION = "RESET_DOMAIN_VERIFICATION";

export const REQUEST_DOMAIN_DNS_CONFIG = "REQUEST_DOMAIN_DNS_CONFIG";
export const GRANT_DOMAIN_DNS_CONFIG = "GRANT_DOMAIN_DNS_CONFIG";
export const REVOKE_DOMAIN_DNS_CONFIG = "REVOKE_DOMAIN_DNS_CONFIG";
export const RESET_DOMAIN_DNS_CONFIG = "RESET_DOMAIN_DNS_CONFIG";

export const SET_SENT_EMAIL_DISPLAY = "SET_SENT_EMAIL_DISPLAY";
export const RESET_SENT_EMAIL_DISPLAY = "RESET_SENT_EMAIL_DISPLAY";

export const REQUEST_MAIL_PLAN_CHANGE = "REQUEST_MAIL_PLAN_CHANGE";
export const GRANT_MAIL_PLAN_CHANGE = "GRANT_MAIL_PLAN_CHANGE";
export const REVOKE_MAIL_PLAN_CHANGE = "REVOKE_MAIL_PLAN_CHANGE";
export const RESET_MAIL_PLAN_CHANGE = "RESET_MAIL_PLAN_CHANGE";

export const REQUEST_PURCHASE_NUMBER = "REQUEST_PURCHASE_NUMBER";
export const GRANT_PURCHASE_NUMBER = "GRANT_PURCHASE_NUMBER";
export const REVOKE_PURCHASE_NUMBER = "REVOKE_PURCHASE_NUMBER";
export const RESET_PURCHASE_NUMBER = "RESET_PURCHASE_NUMBER";

export const REQUEST_ADD_EMAIL_CHANNEL = "REQUEST_ADD_EMAIL_CHANNEL";
export const REVOKE_ADD_EMAIL_CHANNEL = "REVOKE_ADD_EMAIL_CHANNEL";
export const RESET_ADD_EMAIL_CHANNEL = "RESET_ADD_EMAIL_CHANNEL";
export const GRANT_ADD_EMAIL_CHANNEL = "GRANT_ADD_EMAIL_CHANNEL";

export const REQUEST_ADD_SMS_CHANNEL = "REQUEST_ADD_SMS_CHANNEL";
export const REVOKE_ADD_SMS_CHANNEL = "REVOKE_ADD_SMS_CHANNEL";
export const RESET_ADD_SMS_CHANNEL = "RESET_ADD_SMS_CHANNEL";
export const GRANT_ADD_SMS_CHANNEL = "GRANT_ADD_SMS_CHANNEL";

export const REQUEST_DELETE_EMAIL_CHANNEL = "REQUEST_DELETE_EMAIL_CHANNEL";
export const GRANT_DELETE_EMAIL_CHANNEL = "GRANT_DELETE_EMAIL_CHANNEL";
export const REVOKE_DELETE_EMAIL_CHANNEL = "REVOKE_DELETE_EMAIL_CHANNEL";
export const RESET_DELETE_EMAIL_CHANNEL = "RESET_DELETE_EMAIL_CHANNEL";

export const REQUEST_NUMBERS_AVAILABLE = "REQUEST_NUMBERS_AVAILABLE";
export const GRANT_NUMBERS_AVAILABLE = "GRANT_NUMBERS_AVAILABLE";
export const REVOKE_NUMBERS_AVAILABLE = "REVOKE_NUMBERS_AVAILABLE";
export const RESET_NUMBERS_AVAILABLE = "RESET_NUMBERS_AVAILABLE";

export const REQUEST_DELETE_SMS_CHANNEL_NUMBER =
  "REQUEST_DELETE_SMS_CHANNEL_NUMBER";
export const GRANT_DELETE_SMS_CHANNEL_NUMBER =
  "GRANT_DELETE_SMS_CHANNEL_NUMBER";
export const REVOKE_DELETE_SMS_CHANNEL_NUMBER =
  "REVOKE_DELETE_SMS_CHANNEL_NUMBER";
export const RESET_DELETE_SMS_CHANNEL_NUMBER =
  "RESET_DELETE_SMS_CHANNEL_NUMBER";

export const REQUEST_SMS_PLAN_CHANGE = "REQUEST_SMS_PLAN_CHANGE";
export const GRANT_SMS_PLAN_CHANGE = "GRANT_SMS_PLAN_CHANGE";
export const REVOKE_SMS_PLAN_CHANGE = "REVOKE_SMS_PLAN_CHANGE";
export const RESET_SMS_PLAN_CHANGE = "RESET_SMS_PLAN_CHANGE";
